<section class="w-screen h-screen overflow-hidden bg-black text-white flex flex-col justify-center items-center relative pattern-bg">
	<h1 class="text-4xl">Oops!</h1>
	<p class="mt-2">La page n'existe pas, 404.</p>
	<a href="/" class="bg-red-700 rounded-full px-4 py-2 mt-4">Retour à la page d'accueil</a>
	<img src="/assets/img/logo-light.png" class="h-16 absolute bottom-5" alt="Logo">
</section>

<style>
	.pattern-bg {
		background-color: #000000;
		background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='40' height='40' viewBox='0 0 40 40'%3E%3Cg fill-rule='evenodd'%3E%3Cg fill='%23ff0000' fill-opacity='0.095'%3E%3Cpath d='M0 38.59l2.83-2.83 1.41 1.41L1.41 40H0v-1.41zM0 1.4l2.83 2.83 1.41-1.41L1.41 0H0v1.41zM38.59 40l-2.83-2.83 1.41-1.41L40 38.59V40h-1.41zM40 1.41l-2.83 2.83-1.41-1.41L38.59 0H40v1.41zM20 18.6l2.83-2.83 1.41 1.41L21.41 20l2.83 2.83-1.41 1.41L20 21.41l-2.83 2.83-1.41-1.41L18.59 20l-2.83-2.83 1.41-1.41L20 18.59z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");	
	}
</style>